<template>
  <b-row v-if="parentPath && path" style="height:100%;">
    <b-col md="12">
      <b-card
        v-tooltip="uniToolTipTranslation('S654', 'en-US')"
        style="margin-bottom:0px;"
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo,
          minHeight: '540px'
        }"
        class="card-panel"
      >
        <!--
          <div slot="header" :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }">
            {{ uniTranslation("S654") }}
          </div>
        -->
        <div class="row">
          <b-col v-show="lockAll" md="12" style="text-align:right">
            <b-button size="sm" @click="unlock()">
              <i class="fa fa-pencil"></i>
            </b-button>
          </b-col>
          <div class="col-12">
            <!-- === CALCULATION TYPE (Selection, Checking, Simulation) === -->
            <span v-show="calculationTypeVisible">
              <label
                v-tooltip="uniToolTipTranslation('PHE10039', 'en-US')"
                class="pheShoulderLabel"
                >{{ uniTranslation("PHE10039") }}</label
              >

              <!-- === Combo si attiva in PRE CALCOLO === -->
              <el-select
                v-model="calculationTypeValue"
                class="pheShoulderSelect"
                placeholder="Select"
                :disabled="TipoCNN_ByCODE_isActive || lockPostSelezione || lockAll"
              >
                <el-option
                  v-for="item in calculationTypeList"
                  :key="item.id"
                  :label="uniTranslation(item.descrizione)"
                  :value="item.id"
                ></el-option>
              </el-select>
            </span>
            <!-- === CALCULATION MODE (Sales, Tech) === -->
            <span v-show="calculationModeVisible">
              <label
                v-tooltip="uniToolTipTranslation('PHE10040', 'en-US')"
                class="pheShoulderLabel"
                >{{ uniTranslation("PHE10040") }}</label
              >
              <el-select
                v-model="calculationModeValue"
                class="pheShoulderSelect"
                placeholder="Select"
                :disabled="TipoCNN_ByCODE_isActive || lockPostSelezione || lockAll"
              >
                <el-option
                  v-for="item in calculationModeList"
                  :key="item.id"
                  :label="uniTranslation(item.descrizione)"
                  :value="item.id"
                ></el-option>
              </el-select>
            </span>
          </div>
        </div>
        <b-row align-v="center">
          <b-col cols="10">
            <hr />
          </b-col>
          <b-col cols="2">
            <b-button v-if="calculationTypeValue >= 2" size="sm" @click="mostraCodice()">
              {{ TipoCNN_ByCODE_Text }}
            </b-button>
            <b-modal
              v-model="TipoCNN_ByCODE_showModal"
              :title="uniTranslation('PHE10067')"
              @ok="elaboraCodice()"
            >
              <b-form-input v-model="CodeToSet"></b-form-input>
            </b-modal>
          </b-col>
        </b-row>

        <div class="row">
          <!-- 31.10.2019 => Ho cambiato in questa condizione gli && con || mi sembra più corretto!!! === -->
          <div
            v-show="typeOfPheVisible || productLineVisible || designStandardVisible"
            class="col-12"
          >
            <!-- === TYPE OF PHE (BPHE, GPHE) === -->
            <span v-show="typeOfPheVisible">
              <label
                v-tooltip="uniToolTipTranslation('PHE10253', 'en-US')"
                class="pheShoulderLabel"
              >
                {{ uniTranslation("PHE10253") }}
              </label>
              <el-select
                v-model="typeOfPheValue"
                class="pheShoulderSelect"
                placeholder="Select"
                :disabled="$store.getters.status_ArrivoDaSelezione || lockPostSelezione || lockAll"
              >
                <el-option
                  v-for="item in typeOfPheList"
                  :key="item.id"
                  :label="uniTranslation(item.descrizione)"
                  :value="item.id"
                ></el-option>
              </el-select>
            </span>
            <!-- === DESIGN STANDARD (PED, Man) === -->
            <span v-show="designStandardVisible">
              <label
                v-tooltip="uniToolTipTranslation('PHE10042', 'en-US')"
                class="pheShoulderLabel"
              >
                {{ uniTranslation("PHE10042") }}
              </label>
              <el-select
                v-model="designStandardValue"
                class="pheShoulderSelect"
                placeholder="Select"
                :disabled="lockPostSelezione || lockAll"
              >
                <el-option
                  v-for="item in designStandardList"
                  :key="item.id"
                  :label="uniTranslation(item.descrizione)"
                  :value="item.id"
                ></el-option>
              </el-select>
            </span>
            <!-- === PRODUCT LINE (STD, IND, ACS) === -->
            <span v-show="productLineVisible">
              <label
                v-tooltip="uniToolTipTranslation('PHE10043', 'en-US')"
                class="pheShoulderLabel"
              >
                {{ uniTranslation("PHE10043") }}
              </label>
              <el-select
                v-model="productLineValue"
                class="pheShoulderSelect"
                placeholder="Select"
                :disabled="lockPostSelezione || lockAll"
              >
                <el-option
                  v-for="item in productLineList"
                  :key="item.id"
                  :label="uniTranslation(item.descrizione)"
                  :value="item.id"
                ></el-option>
              </el-select>
            </span>
            <!-- === DESIGN PRESSURE (16 bar) === -->
            <span>
              <label
                v-tooltip="uniToolTipTranslation('PHE10044', 'en-US')"
                class="pheShoulderLabel"
                >{{ uniTranslation("PHE10044") }}</label
              >
              <el-select
                v-model="designPressureValue"
                class="pheShoulderSelect"
                placeholder="Select"
                :disabled="lockPostSelezione || lockAll"
              >
                <el-option
                  v-for="item in designPressureList"
                  :key="item.id"
                  :label="uniTranslation(item.descrizione)"
                  :value="item.id"
                ></el-option>
              </el-select>
            </span>
          </div>
        </div>
        <!-- === DESIGN TEMPERATURE === -->
        <div class="row">
          <div class="col-12">
            <el-checkbox
              v-model="designTempEnabled"
              v-tooltip="uniToolTipTranslation('PHE10045', 'en-US')"
              :disabled="lockPostSelezione || lockAll || typeOfPheValue == 2"
              >{{ uniTranslation("PHE10045") }}
            </el-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="col-12" style="margin-left: 15px !important; padding-right: 30px !important;">
            <UnidataEditor
              ref="designT"
              :parent-path="path"
              :name="'.designTemperature'"
              :fixed-decimals="0"
              :show-label="0"
              :show-input="designTempEnabled && typeOfPheValue != 2 ? 1 : 0"
              :show-output1="designTempEnabled && typeOfPheValue != 2 ? 0 : 1"
              :override-um-class="'col-4'"
              :override-input-class="'col-12'"
              :override-output1-class="'col-12'"
              :unidata-editor-columns="'col-10'"
            ></UnidataEditor>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-12">
            <!-- === PLATE MATERIAL === -->
            <div class="row">
              <div class="col-12">
                <el-checkbox
                  v-if="calculationTypeValue == 1"
                  v-model="manualPlateMaterialSelection"
                  v-tooltip="uniToolTipTranslation('PHE580', 'en-US')"
                  :disabled="lockPostSelezione || lockAll"
                  >{{ uniTranslation("PHE580") }}
                </el-checkbox>
              </div>
            </div>
            <span>
              <label
                v-if="calculationTypeValue != 1"
                v-tooltip="uniToolTipTranslation('PHE580', 'en-US')"
                class="pheShoulderLabel"
                >{{ uniTranslation("PHE580") }}</label
              >

              <el-select
                v-if="manualPlateMaterialSelection"
                v-model="platesMaterialValue"
                class="pheShoulderSelect"
                placeholder="Select"
                :disabled="lockPostSelezione || lockAll"
              >
                <el-option
                  v-for="item in platesMaterialList"
                  :key="item.id"
                  :label="uniTranslation(item.descrizione)"
                  :value="item.id"
                ></el-option>
              </el-select>

              <el-select
                v-if="!manualPlateMaterialSelection"
                :value="$t('PHEALLPLATEMATERIAL')"
                class="pheShoulderSelect"
                :placeholder="$t('PHEALLPLATEMATERIAL')"
                :disabled="true"
              >
              </el-select>
            </span>
            <!-- === PLATE THICKNESS === -->
            <span v-show="calculationTypeValue != 1 && typeOfPheValue == 1">
              <label v-tooltip="uniToolTipTranslation('PHE2223', 'en-US')" class="pheShoulderLabel">
                {{ uniTranslation("PHE2223") }}
              </label>
              <el-select
                v-model="platesThicknessValue"
                class="pheShoulderSelect"
                placeholder="Select"
                :disabled="lockPostSelezione || lockAll"
              >
                <el-option
                  v-for="item in platesThicknessList"
                  :key="item.id"
                  :label="uniTranslation(item.descrizione)"
                  :value="item.id"
                ></el-option>
              </el-select>
            </span>
            <!-- === GASKET MATERIAL === -->
            <span>
              <!-- se piastre con guarnizione o saldobrasate deve cambiare l'etichetta -->

              <label
                v-show="typeOfPheValue == 1"
                v-tooltip="uniToolTipTranslation('PHE579', 'en-US')"
                class="pheShoulderLabel"
              >
                {{ uniTranslation("PHE579") }}
              </label>

              <label
                v-show="typeOfPheValue == 2"
                v-tooltip="uniToolTipTranslation('PHE1514', 'en-US')"
                class="pheShoulderLabel"
              >
                {{ uniTranslation("PHE1514") }}
              </label>

              <el-select
                v-model="gasketsMaterialValue"
                class="pheShoulderSelect"
                placeholder="Select"
                :disabled="lockPostSelezione || lockAll"
              >
                <el-option
                  v-for="item in gasketsMaterialList"
                  :key="item.id"
                  :label="uniTranslation(item.descrizione)"
                  :value="item.id"
                ></el-option>
              </el-select>
            </span>
            <!-- === FRAME MATERIAL === -->
            <span>
              <label v-tooltip="uniToolTipTranslation('PHE578', 'en-US')" class="pheShoulderLabel">
                {{ uniTranslation("PHE578") }}
              
              </label>
              <el-select
                v-model="framesMaterialValue"
                class="pheShoulderSelect"
                placeholder="Select"
                :disabled="lockPostSelezione || lockAll"
              >
                <el-option
                  v-for="item in framesMaterialList"
                  :key="item.id"
                  :label="uniTranslation(item.descrizione)"
                  :value="item.id"
                ></el-option>
              </el-select>
            </span>
            <!-- === GEOMETRY === -->
            <!-- :disabled="lockPostSelezioneVerifica"  -->
            <span
              v-show="(sizeGeometryVisible || typeGeometryVisible) && calculationTypeValue != 1"
            >
              <label
                v-tooltip="uniToolTipTranslation('PHE582', 'en-US')"
                class="pheShoulderLabel"
                >{{ uniTranslation("PHE582") }}</label
              >
              <el-select
                v-show="sizeGeometryVisible || visibleAll"
                v-model="sizeGeometryValue"
                class="pheShoulderSelect"
                placeholder="Select"
                :disabled="lockPostSelezioneVerifica || lockAll"
              >
                <el-option
                  v-for="item in sizeGeometryList"
                  :key="item.id"
                  :label="item.descrizioneLogo"
                  :value="item.id"
                ></el-option>
              </el-select>
              <el-select
                v-show="typeGeometryVisible || visibleAll"
                v-model="typeGeometryValue"
                class="pheShoulderSelect"
                placeholder="Select"
                :disabled="lockAll"
              >
                <el-option
                  v-for="item in typeGeometryList"
                  :key="item.id"
                  :label="fixForLogo(uniTranslation(item.descrizione))"
                  :value="item.id"
                ></el-option>
              </el-select>
            </span>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
//import Loading from "vue-loading-overlay";
import UnidataEditor from "../unidata/UnidataEditor";
import { mapGetters } from "vuex";
import { /*Radio,*/ Select, Option /*, Collapse, CollapseItem*/, Checkbox } from "element-ui";
import jsonHelper from "../../shared/jsonHelper";
import geometryPHEServiceCipriani from "../../services/backend/geometryPHEServiceCipriani";
import projectService from "../../services/backend/projectService";
import colorsService from "../../services/backend/colorsService";
import { Notification } from "element-ui";

import * as statuses from "../../store/modules/projectStore_Constants";

function findDefaultV(list) {
  if (list && list.length > 0) {
    let retVal = list[0].id;
    for (let i = 0; i < list.length; i++) {
      if (list[i].defaultV) {
        retVal = list[i].id;
      }
    }
    return retVal;
  } else {
    return 0;
  }
}

function useOrFindDefaultV(list, def) {
  if (def) {
    if (def >= 0) {
      // Controlla se il valore def è all'interno della lista
      var idExisting = false;
      for (let i = 0; i < list.length; i++) {
        if (list[i].id == def) {
          idExisting = true;
        }
      }
      if (idExisting) {
        return def;
      }
    }
  }
  return findDefaultV(list);
}

export default {
  name: "PheProjectAdvancedDetails",
  components: {
    UnidataEditor,
    "el-select": Select,
    "el-option": Option,
    "el-checkbox": Checkbox
    //Loading
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    },
    visibleAll: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      path: null,
      coloreSfondo: "",
      coloreBarraTitolo: "",
      coloreTitolo: "",
      coloreTesto: "",
      coloreBordo: "",
      loading: false,

      designTempEnabled: false,

      calculationTypeValue: null,
      calculationModeValue: null,
      typeOfPheValue: null,
      designStandardValue: null,
      productLineValue: null,
      designPressureValue: null,
      platesMaterialValue: null,
      platesThicknessValue: null,
      gasketsMaterialValue: null,
      framesMaterialValue: null,
      sizeGeometryValue: null,
      typeGeometryValue: null,

      calculationTypeValue_postSele: 0,
      calculationModeValue_postSele: 0,
      typeOfPheValue_postSele: 0,
      designStandardValue_postSele: 0,
      productLineValue_postSele: 0,
      designPressureValue_postSele: 0,
      platesMaterialValue_postSele: 0,
      platesThicknessValue_postSele: 0,
      gasketsMaterialValue_postSele: 0,
      framesMaterialValue_postSele: 0,
      sizeGeometryValue_postSele: 0,
      typeGeometryValue_postSele: 0,

      calculationTypeVisible: true,
      calculationModeVisible: true,
      typeOfPheVisible: true,
      designStandardVisible: true,
      productLineVisible: true,
      designPressureVisible: true,
      platesMaterialVisible: true,
      platesThicknessVisible: true,
      gasketsMaterialVisible: true,
      framesMaterialVisible: true,
      sizeGeometryVisible: false,
      typeGeometryVisible: false,

      CodeToSet: "",

      // *******************
      // Connessioni imposte (TipoCNN_ByCODE)
      // *******************
      TipoCNN_ByCODE_showModal: false,
      TipoCNN_ByCODE_isActive: false,
      TipoCNN_ByCODE_Text: "...",
      // *******************

      unsubscribes: [],

      modalita: 2,

      designTS: 80,
      designTS_Last: 0,
      lastCalculatedDesignTS: null,

      newDatoInput: 1,

      loghiData: [],

      Rif_PlatesThickness_typeOfPheValue: -9999,
      Rif_PlatesThickness_idTaglia: -9999,
      Rif_PlatesThickness_list: null,

      lockAllvalue: false,

      manualPlateMaterialSelection: true
    };
  },
  computed: {
    ...mapGetters(["projects", "disableCalcolate", "currentLanguage"]),
    lockPostSelezione: function() {
      let retVal = this.$store.getters.status_Selezione && this.$store.getters.status_PostCalcolo;
      return retVal;
    },
    lockPostSelezioneVerifica: function() {
      return (
        (this.$store.getters.status_Selezione && this.$store.getters.status_PostCalcolo) ||
        (this.$store.getters.status_Verifica && this.$store.getters.status_ArrivoDaSelezione)
      );
    },
    lockAll: function() {
      if (this.lockPostSelezioneVerifica) {
        return this.lockAllvalue;
      } else {
        return false;
      }
    },
    BPHE_TS: function() {
      return 200;
    },
    GPHE_TS: function() {
      return 110;
    }
  },
  asyncComputed: {
    calculationTypeList: async function() {
      let list = null;
      let that = this;
      await geometryPHEServiceCipriani.getCalculationType().then(function(data) {
        list = data;
        if (list) {
          that.calculationTypeValue = useOrFindDefaultV(list, that.calculationTypeValue_postSele);
        }
      });

      return list;
    },
    calculationModeList: async function() {
      let list = null;
      let that = this;
      await geometryPHEServiceCipriani.getCalculationMode().then(function(data) {
        list = data;
        if (list) {
          that.calculationModeValue = useOrFindDefaultV(list, that.calculationModeValue_postSele);
          that.calculationModeVisible = list.length > 1;
        }
      });

      return list;
    },
    typeOfPheList: async function() {
      let list = null;
      let that = this;
      /*  && this.calculationTypeList */
      await geometryPHEServiceCipriani
        .getTypeOfPhe() /* , this.calculationTypeValue */
        .then(function(data) {
          list = data;
          if (list) {
            console.log("TIPO SCAMB ------------");
            console.log("typeOfPheValue: " + that.typeOfPheValue);
            console.log("typeOfPheValue_postSele: " + that.typeOfPheValue_postSele);
            console.log("-----------------------");

            that.typeOfPheValue = useOrFindDefaultV(list, that.typeOfPheValue_postSele);
            that.typeOfPheVisible = list.length > 1;
          }
        });

      return list;
    },
    designStandardList: async function() {
      let list = null;
      let that = this;
      /*  && this.calculationTypeList */
      await geometryPHEServiceCipriani
        .getDesignStandard() /* , this.calculationTypeValue */
        .then(function(data) {
          list = data;
          if (list) {
            that.designStandardValue = useOrFindDefaultV(list, that.designStandardValue_postSele);
            that.designStandardVisible = list.length > 1;
          }
        });

      return list;
    },
    productLineList: async function() {
      let list = null;
      let that = this;
      if (this.typeOfPheValue && this.calculationModeValue) {
        /*  && this.calculationTypeList */
        await geometryPHEServiceCipriani
          .getProductLine(
            this.typeOfPheValue,
            this.calculationModeValue
          ) /* , this.calculationTypeValue */
          .then(function(data) {
            list = data;
            if (list) {
              that.productLineValue = useOrFindDefaultV(list, that.productLineValue_postSele);
            }
          });
      }
      return list;
    },
    designPressureList: async function() {
      let list = null;
      let that = this;
      if (this.calculationTypeValue && this.typeOfPheValue && this.productLineValue) {
        await geometryPHEServiceCipriani
          .getDesignPressure(this.calculationTypeValue, this.typeOfPheValue, this.productLineValue)
          .then(function(data) {
            list = data;
            if (list) {
              that.designPressureValue = useOrFindDefaultV(list, that.designPressureValue_postSele);
            }
          });
      }
      return list;
    },
    platesMaterialList: async function() {
      let list = null;
      let that = this;
      if (
        this.calculationTypeValue &&
        this.typeOfPheValue &&
        this.designStandardValue &&
        this.productLineValue &&
        this.designPressureValue
      ) {
        //let modalita = 8;
        await geometryPHEServiceCipriani
          .getPlatesMaterial(
            this.calculationTypeValue,
            this.modalita,
            this.typeOfPheValue,
            this.designStandardValue,
            this.productLineValue,
            this.designPressureValue
          )
          .then(function(data) {
            list = data;
            if (list) {
              that.platesMaterialValue = useOrFindDefaultV(
                list,
                that.platesMaterialValue_postSele
              ); /* that.platesMaterialValue_postSele */
            }
          });
      }
      return list;
    },
    platesThicknessList: async function() {
      let list = null;
      let that = this;

      var fromSelezione = that.$store.getters.calcStatus.includes("ARRIVO_DA_SELEZIONE") == true;
      var idTaglia = -1;

      var ricarica = true;
      if (fromSelezione == true) {
        //idTaglia = this.sizeGeometryValue;
        idTaglia = that.sizeGeometryValue_postSele;
        //------------------------
        //Andrea 26.10.2020
        //------------------------
        if (idTaglia == null) {
          idTaglia = -1;
        }
        //------------------------
        if (
          that.Rif_PlatesThickness_typeOfPheValue == that.typeOfPheValue &&
          that.Rif_PlatesThickness_idTaglia == idTaglia &&
          that.Rif_PlatesThickness_list != null
        ) {
          ricarica = false;
          list = that.Rif_PlatesThickness_list;
          //alert(ricarica);
        }
      }

      //alert("fromSelezione = " + fromSelezione);

      if (
        /*this.profileList && this.calculationTypeList &&*/ this.typeOfPheValue &&
        this.designStandardValue &&
        this.productLineValue &&
        ricarica
      ) {
        await geometryPHEServiceCipriani
          .getPlatesThicknessNew(
            this.typeOfPheValue,
            this.designStandardValue,
            this.productLineValue,
            idTaglia
          )
          .then(function(data) {
            list = data;
            // alert(JSON.stringify(list));
            // alert(that.platesThicknessValue);
            // alert(that.platesThicknessValue_postSele);
            that.Rif_PlatesThickness_typeOfPheValue = that.typeOfPheValue;
            that.Rif_PlatesThickness_idTaglia = idTaglia;
            that.Rif_PlatesThickness_list = data;
            if (list) {
              that.platesThicknessValue = useOrFindDefaultV(
                list,
                that.platesThicknessValue_postSele
              );
            }
          });
      }
      return list;
    },
    calculatedDesignTS: async function() {
      let retValue = this.lastCalculatedDesignTS;
      let that = this;

      if (that.typeOfPheValue == 2) return that.BPHE_TS;

      if (
        this.calculationTypeValue &&
        this.typeOfPheValue &&
        this.designStandardValue &&
        this.productLineValue &&
        this.designPressureValue &&
        this.designTS &&
        (this.designTempEnabled || !this.designTempEnabled) &&
        this.newDatoInput
      ) {
        //let modalita = 8;
        //let designTemp = 90;

        let designTempUms = jsonHelper.getProperty(
          that.projects,
          that.path + ".designTemperature.input.usrValue.um"
        );

        let leftPanel = jsonHelper.getProperty(that.projects, that.parentPath + ".left");
        let rightPanel = jsonHelper.getProperty(that.projects, that.parentPath + ".right");

        await geometryPHEServiceCipriani
          .getCalculateTS(
            this.calculationTypeValue,
            this.modalita,
            this.designTempEnabled,
            this.designTS,
            designTempUms,
            leftPanel,
            rightPanel
          )
          .then(function(data) {
            if (data) {
              retValue = data;
              that.lastCalculatedDesignTS = data;
              that.AggiornaDesignTemperature(retValue);
            }
          });
      }
      return retValue;
    },
    gasketsMaterialList: async function() {
      let list = null;
      let that = this;

      if (
        this.calculationTypeValue &&
        this.typeOfPheValue &&
        this.designStandardValue &&
        this.productLineValue &&
        this.designPressureValue &&
        this.designTS &&
        (this.designTempEnabled || !this.designTempEnabled) &&
        this.newDatoInput
      ) {
        //let modalita = 8;
        //let designTemp = 90;

        let designTempUms = jsonHelper.getProperty(
          that.projects,
          that.path + ".designTemperature.input.usrValue.um"
        );

        let leftPanel = jsonHelper.getProperty(that.projects, that.parentPath + ".left");
        let rightPanel = jsonHelper.getProperty(that.projects, that.parentPath + ".right");

        //Andrea 17.02.2021=> Provo a prenderla dal progetto
        //---------------------
        var gasketsMaterialValueP = jsonHelper.getProperty(
          that.projects,
          that.parentPath + ".shoulder.idGasketsMaterial"
        );
        //alert(gasketsMaterialValueP);
        //if (gasketsMaterialValueP != this.gasketsMaterialValue) {
        //  this.gasketsMaterialValue = gasketsMaterialValueP;
        //}
        //---------------------

        if (that.designTS != that.designTS_Last) {
          that.$store.commit("disabiltaCalcola");
        }

        await geometryPHEServiceCipriani
          .getGasketsMaterial(
            this.calculationTypeValue,
            this.modalita,
            this.typeOfPheValue,
            this.designStandardValue,
            this.productLineValue,
            this.designPressureValue,
            this.designTempEnabled,
            this.designTS,
            designTempUms,
            leftPanel,
            rightPanel,
            gasketsMaterialValueP
          )
          .then(function(data) {
            list = data;
            that.designTS_Last = that.designTS;
            if (list) {
              setTimeout(() => {
                that.gasketsMaterialValue_postSele = gasketsMaterialValueP; //Andrea 17.02.2021=> Provo a forzare!!
                that.gasketsMaterialValue = useOrFindDefaultV(
                  list,
                  that.gasketsMaterialValue_postSele
                );
              }, 50);
            }
          });
      } else {
        console.log("Else");
      }

      if (this.disableCalcolate) {
        that.$store.commit("abilitaCalcola");
      }

      return list;
    },
    framesMaterialList: async function() {
      let list = null;
      let that = this;

      var fromSelezione = that.$store.getters.calcStatus.includes("ARRIVO_DA_SELEZIONE") == true;

      var idTaglia = -1;

      if (fromSelezione == true) {
        idTaglia = this.sizeGeometryValue;
        //------------------------
        //Andrea 26.10.2020
        //------------------------
        if (idTaglia == null) {
          idTaglia = -1;
        }
        //------------------------
      }

      if (
        this.calculationTypeValue &&
        this.typeOfPheValue &&
        this.designStandardValue &&
        this.productLineValue &&
        this.designPressureValue
      ) {
        //let modalita = 8;
        await geometryPHEServiceCipriani
          .getFramesMaterial(
            this.calculationTypeValue,
            this.modalita,
            this.typeOfPheValue,
            this.designStandardValue,
            this.productLineValue,
            this.designPressureValue,
            idTaglia
          )
          .then(function(data) {
            list = data;
            if (list) {
              //MARCO DC 26/02/2025
              //Ho cambiato da that.framesMaterialValue_postSele) a that.projects[that.parentPath]["shoulder"]["idFramesMaterial"]
              //Perchè ho notato che dopo il calcolo il materiale veniva resettato, controllando ho notato che framesMaterialValue_postSele non viene aggiornato spesso
              //Quindi uso come default quello che è selezionato in questo momento
              that.framesMaterialValue = useOrFindDefaultV(list,that.projects[that.parentPath]["shoulder"]["idFramesMaterial"]);// that.framesMaterialValue_postSele);
            }
          });
      }
      return list;
    },
    sizeGeometryList: async function() {
      let list = null;
      let that = this;

      that.sizeGeometryVisible = false;
      if (
        this.calculationTypeValue &&
        /*this.typeOfPheValue &&*/
        this.designStandardValue &&
        this.productLineValue &&
        this.designPressureValue &&
        this.framesMaterialValue &&
        this.platesMaterialValue &&
        this.gasketsMaterialValue &&
        this.platesThicknessValue
      ) {
        var fromSelezione = that.$store.getters.calcStatus.includes("ARRIVO_DA_SELEZIONE") == true;
        await geometryPHEServiceCipriani
          .getSizeGeometry(
            this.calculationTypeValue,
            this.designStandardValue,
            this.productLineValue,
            this.designPressureValue,
            this.framesMaterialValue,
            this.platesMaterialValue,
            this.gasketsMaterialValue,
            this.platesThicknessValue,
            this.typeOfPheValue
          )
          .then(function(data) {
            list = data;
            if (list) {
              that.sizeGeometryValue = useOrFindDefaultV(list, that.sizeGeometryValue_postSele);
              that.sizeGeometryVisible = true;
              if (fromSelezione) {
                that.sizeGeometryValue = that.sizeGeometryValue_postSele;
              }
            }
          });
      }
      return list;
    },
    typeGeometryList: async function() {
      let list = null;
      let that = this;
      that.typeGeometryVisible = false;
      if (
        this.calculationTypeValue &&
        this.typeOfPheValue &&
        this.productLineValue &&
        this.sizeGeometryValue
      ) {
        await geometryPHEServiceCipriani
          .getTypeGeometry(
            this.calculationTypeValue,
            this.typeOfPheValue,
            this.productLineValue,
            this.sizeGeometryValue
          )
          .then(function(data) {
            list = data.lista;
            that.loghiData = data.loghiData;
            if (list) {
              that.typeGeometryValue = useOrFindDefaultV(list, that.typeGeometryValue_postSele);
              that.typeGeometryVisible = true;

              // serve per visualizzare/nascondere la combo
              // della percentuale di resa nel "bottom"
              that.$store.commit("changeTypeOfPheChannel", that.typeGeometryValue);
            }
          });
      }
      return list;
    }
  },
  watch: {
    manualPlateMaterialSelection: function(nv, ov) {
      let that = this;

      //alert(nv);
      //alert(that.path);

      this.$store.dispatch("changeProjectProperty", {
        path: that.path + ".calculateWithAllPlateMaterial",
        value: !nv
      });
    },
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    },
    calculationTypeValue: function(nv, ov) {
      let that = this;

      //alert(nv);
      //alert(that.path);

      if (nv !== ov) {
        this.$store.commit("changeCalculationType", nv);
        this.$store.dispatch("changeProjectProperty", {
          path: that.path + ".idCalculationType",
          value: nv
        });
        that.resetInputForm();
        if (nv == 1) {
          that.$store.dispatch("ensureStatus", statuses.SELEZIONE);
          that.impostaCheckMaterialiPiastre();
        } else {
          that.$store.dispatch("ensureStatus", statuses.VERIFICA);
          that.manualPlateMaterialSelection = true;
        }
      }
    },
    calculationModeValue: function(nv, ov) {
      let that = this;
      this.$store.dispatch("changeProjectProperty", {
        path: that.path + ".idCalculationMode",
        value: nv
      });
      if (nv !== ov) {
        that.resetInputForm();
      }
    },
    typeOfPheValue: function(nv, ov) {
      let that = this;

      var pv = jsonHelper.getProperty(that.projects, that.path + ".idTypeOfPhe");

      this.$store.commit("changeTypeOfPhe", nv);
      if (pv != nv) {
        this.$store.dispatch("changeProjectProperty", {
          path: that.path + ".idTypeOfPhe",
          value: nv
        });

        if (nv != ov && that.$refs.designT != null) {
          if (nv == 2) {
            //BPHE
            that.designTempEnabled = true;
            that.$refs.designT.setValue(that.BPHE_TS, "°C");
          } else {
            that.$refs.designT.setValue(that.GPHE_TS, "°C"); //GPHE
          }
        }

        if (nv !== ov) {
          that.resetInputForm();
        }
      }
    },
    designStandardValue: function(nv, ov) {
      let that = this;
      this.$store.dispatch("changeProjectProperty", {
        path: that.path + ".idDesignStandard",
        value: nv
      });
      if (nv !== ov) {
        that.resetInputForm();
      }
    },
    productLineValue: function(nv, ov) {
      let that = this;
      this.$store.dispatch("changeProjectProperty", {
        path: that.path + ".idProductLine",
        value: nv
      });
      if (nv !== ov) {
        that.resetInputForm();
      }
    },
    designPressureValue: function(nv, ov) {
      let that = this;
      this.$store.dispatch("changeProjectProperty", {
        path: that.path + ".idDesignPressure",
        value: nv
      });
      if (nv !== ov) {
        that.resetInputForm();
      }
    },
    designTempEnabled: function(nv, ov) {
      let that = this;

      var pv = jsonHelper.getProperty(that.projects, that.path + ".designTempEnabled");

      if (pv != nv) {
        this.$store.dispatch("changeProjectProperty", {
          path: that.path + ".designTempEnabled",
          value: nv
        });
        if (nv !== ov) {
          that.resetInputForm();
        }
      }
    },
    calculatedDesignTS: function(nv /*, ov*/) {
      //console.log("ASHDAHSHGDBAWKJSBDKNAS D");
      //this.settaValore("designTemperature", nv, true, true, true);
      //console.log("CAMBIOOO > " + nv);
      /*if (nv !== ov) {
        that.resetInputForm();
      }*/
    },
    platesMaterialValue: function(nv, ov) {
      let that = this;
      this.$store.dispatch("changeProjectProperty", {
        path: that.path + ".idPlatesMaterial",
        value: nv
      });

      if (nv !== ov) {
        that.resetInputForm();
      }
    },
    platesThicknessValue: function(nv, ov) {
      let that = this;
      this.$store.dispatch("changeProjectProperty", {
        path: that.path + ".idPlatesThickness",
        value: nv
      });
      if (nv !== ov) {
        that.resetInputForm();
      }
    },
    gasketsMaterialValue: function(nv, ov) {
      let that = this;
      this.$store.dispatch("changeProjectProperty", {
        path: that.path + ".idGasketsMaterial",
        value: nv
      });
      if (nv !== ov) {
        that.resetInputForm();
      }
    },
    framesMaterialValue: function(nv, ov) {
      let that = this;
      
      this.$store.dispatch("changeProjectProperty", {
        path: that.path + ".idFramesMaterial",
        value: nv
      });
      if (nv !== ov) {
        that.resetInputForm();
      }
    },
    sizeGeometryValue: function(nv, ov) {
      let that = this;

      this.$store.dispatch("changeProjectProperty", {
        path: that.path + ".idSizeGeometry",
        value: nv
      });
      if (nv !== ov) {
        that.resetInputForm();
      }
    },
    typeGeometryValue: function(nv, ov) {
      let that = this;
      this.$store.dispatch("changeProjectProperty", {
        path: that.path + ".idTypeGeometry",
        value: nv
      });

      // serve per visualizzare/nascondere la combo
      // della percentuale di resa nel "bottom"
      this.$store.commit("changeTypeOfPheChannel", nv);

      if (nv !== ov) {
        that.resetInputForm();
      }
    }
  },
  destroyed: function() {
    this.unsubscribes.forEach(function(u) {
      u();
    });
  },
  mounted: function() {
    var that = this;
    if (this.parentPath && this.localPath) {
      this.path = this.parentPath + this.localPath;

      that.modalita = jsonHelper.getProperty(that.projects, that.parentPath + ".modality");

      that.impostaCheckMaterialiPiastre();

      //Andrea 12.05.2021
      that.designTempEnabled = jsonHelper.getProperty(
        that.projects,
        that.path + ".designTempEnabled"
      );

      if (that.designTempEnabled) {
        var ipV = jsonHelper.getProperty(
          that.projects,
          that.parentPath + ".innerProject.ciprianI_TS"
        );
        //alert(ipV);
        if (ipV) {
          that.designTS = ipV;
          that.designTS_Last = ipV;
        }
      }

      //colorsService.getColoriCard().then(function(data) {
      var colorList = colorsService.getColoriCard();
      that.coloreSfondo = colorList[0] + " !important"; // 4 elem: 0=sfondo 1=barra con titolo 2=testo 3=titolo
      that.coloreBarraTitolo = colorList[1]; // 3 elem non usati + altri 2
      that.coloreTesto = colorList[2];
      that.coloreTitolo = colorList[3];
      that.coloreBordo = colorList[6];
      // alert("colore bordo = " + that.coloreBordo);
      //});

      var spallaCaricata = jsonHelper.getProperty(that.projects, that.path + ".configured");
      if (spallaCaricata) {
        this.ripristinaSpallaDaProgetto();
      }

      that.unsubscribes.push(
        that.$store.subscribe(function(mutation /*, state*/) {
          if (mutation.type === "changeProjectProperty") {
            let pathTS = that.path + ".designTemperature.input.refValue.value";
            if (mutation.payload.path.startsWith(pathTS)) {
              that.designTS = mutation.payload.value;
            }
          }

          if (mutation.type === "changeProjectProperty") {
            let path6 = that.parentPath + ".right.saturationTemperature.input.usrValue.value";
            if (mutation.payload.path.startsWith(path6)) {
              if (that.newDatoInput == 1) {
                that.newDatoInput = 2;
              } else {
                that.newDatoInput = 1;
              }
            }
          }

          if (mutation.type === "userInputChanged") {
            let path1 = that.parentPath + ".left.inletTemperature.input.usrValue.value";
            let path2 = that.parentPath + ".left.outletTemperature.input.usrValue.value";
            let path3 = that.parentPath + ".right.inletTemperature.input.usrValue.value";
            let path4 = that.parentPath + ".right.outletTemperature.input.usrValue.value";
            let path5 = that.parentPath + ".right.saturationPressure.input.usrValue.value";
            let path6 = that.parentPath + ".right.saturationTemperature.input.usrValue.value";
            if (
              mutation.payload.path.startsWith(path1) ||
              mutation.payload.path.startsWith(path2) ||
              mutation.payload.path.startsWith(path3) ||
              mutation.payload.path.startsWith(path4) ||
              mutation.payload.path.startsWith(path5) ||
              mutation.payload.path.startsWith(path6)
            ) {
              if (that.newDatoInput == 1) {
                that.newDatoInput = 2;
              } else {
                that.newDatoInput = 1;
              }
            }
          }

          if (mutation.type === "refreshAll") {
            var spallaConfigurata = jsonHelper.getProperty(
              that.projects,
              that.path + ".configured"
            );
            if (spallaConfigurata && that.$store.getters.status_PreCalcolo) {
              that.ripristinaSpallaDaProgetto();
            }
          } else if (mutation.type === "impostaDatiSpallaDaSelezione") {
            that.ripristinaSpallaDaOggetto(mutation.payload);
            that.calculationTypeValue = 2;
          } /* else if (mutation.type === "ripristinaStatoSpalla" && mutation.payload) {
            that.loading = true;
            that.ripristinaSpallaDaOggetto(mutation.payload);
            that.calculationTypeValue = 1;
            that.loading = false;
          } */
        })
      );
    }
  },
  methods: {
    AggiornaDesignTemperature(nv) {
      this.settaValore("designTemperature", nv, true, true, true);
      projectService.syncShoulder(this.projects);
    },
    impostaCheckMaterialiPiastre: function() {
      var that = this;

      that.manualPlateMaterialSelection = !jsonHelper.getProperty(
        that.projects,
        that.parentPath + ".calculateWithAllPlateMaterial"
      );
    },
    unlock() {
      this.lockAllvalue = false;
      this.bDisableNextDaSpalla();
    },
    fixForLogo(descriz) {
      //ANDREA 23.09.2020 => non ho trovato soluzioni migliori
      var x = descriz;
      var i;
      for (i = 0; i < this.loghiData.length; i++) {
        //if (this.loghiData[i].idTipo == this.typeOfPheValue) {
        x = x.replace(this.loghiData[i].codice + " ", this.loghiData[i].codiceLogo + " ");
        //}
      }
      return x;
    },

    settaValoreDiretto(elemento, valore) {
      // var that = this;
      // console.log(this.parentPath + "." + elemento + " => " + valore);
      var el = this.parentPath + "." + elemento;
      this.$store.dispatch("changeProjectProperty", {
        path: el,
        value: valore
      });
    },

    settaValoreParent(elemento, valore, input, output, bilancio) {
      var el = this.parentPath + "." + elemento;
      this.settaValoreFunc(el, valore, input, output, bilancio);
    },

    settaValore(elemento, valore, input, output, bilancio) {
      var el = this.path + "." + elemento;
      this.settaValoreFunc(el, valore, input, output, bilancio);
      this.$store.dispatch("refreshAll");
    },

    settaValoreFunc(el, valore, input, output, bilancio) {
      if (input) {
        this.settaValoreUM(el + ".input.refValue.value", valore);
        this.settaValoreUM(el + ".input.usrValue.value", valore);
      }
      if (output) {
        this.settaValoreUM(el + ".output.refValue.value", valore);
        this.settaValoreUM(el + ".output.usrValue.value", valore);
      }
      if (bilancio) {
        this.settaValoreUM(el + ".outputBilancio.refValue.value", valore);
        this.settaValoreUM(el + ".outputBilancio.usrValue.value", valore);
      }
      //this.$store.dispatch("refreshAll");
    },

    settaValoreUM(elementoUM, valore) {
      // var that = this;
      //console.log(elementoUM + " => " + valore);
      this.$store.dispatch("changeProjectProperty", {
        path: elementoUM,
        value: valore
      });
    },

    azzera_Rif_PlatesThickness() {
      this.Rif_PlatesThickness_typeOfPheValue = -9999;
      this.Rif_PlatesThickness_idTaglia = -9999;
      this.Rif_PlatesThickness_list = null;
    },

    resetInputForm() {
      if (!this.$store.getters.status_ArrivoDaSelezione && !this.loading) {
        if (this.$store.getters.status_PostCalcolo && !this.$store.getters.status_Selezione) {
          // svuotare le variabili che ricordano il precedente valore di
          // impostazione della spalla
          this.azzera_Rif_PlatesThickness();

          this.calculationTypeValue_postSele = null;
          this.calculationModeValue_postSele = null;
          this.typeOfPheValue_postSele = null;
          this.designStandardValue_postSele = null;
          this.productLineValue_postSele = null;
          this.designPressureValue_postSele = null;
          this.platesMaterialValue_postSele = null;
          this.platesThicknessValue_postSele = null;
          this.gasketsMaterialValue_postSele = null;
          this.framesMaterialValue_postSele = null;
          this.sizeGeometryValue_postSele = null;
          this.typeGeometryValue_postSele = null;

          // PRE_CALCOLO
          this.$store.dispatch("ensureStatus", statuses.PRE_CALCOLO);
        }
      }

      this.bDisableNextDaSpalla();
    },
    getShortCalculationTypeList: function(list) {
      if (list) {
        // Non visualizzare nella combo
        // la SELEZIONE
        var list_sel = [];
        list.forEach(function(item) {
          if (item.id != 1) {
            list_sel.push(item);
          }
        });
        list = list_sel;
        return list;
      }
    },
    returnToSelectionList() {
      this.calculationTypeValue = 1;
    },
    ripristinaSpallaDaProgetto() {
      var that = this;
      that.azzera_Rif_PlatesThickness();

      that.calculationTypeValue_postSele = jsonHelper.getProperty(
        that.projects,
        that.path + ".idCalculationType"
      );
      that.calculationModeValue_postSele = jsonHelper.getProperty(
        that.projects,
        that.path + ".idCalculationMode"
      );
      that.typeOfPheValue_postSele = jsonHelper.getProperty(
        that.projects,
        that.path + ".idTypeOfPhe"
      );
      that.designStandardValue_postSele = jsonHelper.getProperty(
        that.projects,
        that.path + ".idDesignStandard"
      );
      that.productLineValue_postSele = jsonHelper.getProperty(
        that.projects,
        that.path + ".idProductLine"
      );
      that.designPressureValue_postSele = jsonHelper.getProperty(
        that.projects,
        that.path + ".idDesignPressure"
      );
      that.platesMaterialValue_postSele = jsonHelper.getProperty(
        that.projects,
        that.path + ".idPlatesMaterial"
      );
      that.gasketsMaterialValue_postSele = jsonHelper.getProperty(
        that.projects,
        that.path + ".idGasketsMaterial"
      );
      that.framesMaterialValue_postSele = jsonHelper.getProperty(
        that.projects,
        that.path + ".idFramesMaterial"
      );
      that.platesThicknessValue_postSele = jsonHelper.getProperty(
        that.projects,
        that.path + ".idPlatesThickness"
      );
      that.sizeGeometryValue_postSele = jsonHelper.getProperty(
        that.projects,
        that.path + ".idSizeGeometry"
      );
      that.typeGeometryValue_postSele = jsonHelper.getProperty(
        that.projects,
        that.path + ".idTypeGeometry"
      );
    },
    ripristinaSpallaDaOggetto(value) {
      var that = this;

      value.passaInVerificaDaSelezione = value.passaInVerificaDaSelezione || false;

      if (value.passaInVerificaDaSelezione == false) {
        // alert("ripristinaSpallaDaOggetto");
        that.azzera_Rif_PlatesThickness();
        that.calculationTypeValue_postSele = value.idCalculationTypeValue;
        that.calculationModeValue_postSele = value.idCalculationModeValue;
        that.typeOfPheValue_postSele = value.idTypeOfPheValue;
        that.designStandardValue_postSele = value.idDesignStandardValue;
        that.productLineValue_postSele = value.idProductLineValue;
        that.designPressureValue_postSele = value.idDesignPressureValue;
        that.platesMaterialValue_postSele = value.idPlatesMaterialValue;
        that.gasketsMaterialValue_postSele = value.idGasketsMaterialValue;
        that.framesMaterialValue_postSele = value.idFramesMaterialValue;
        that.platesThicknessValue_postSele = value.idPlatesThickness;
        that.sizeGeometryValue_postSele = value.idSizeGeometry;
        that.typeGeometryValue_postSele = value.idTypeGeometry;
      } else {
        //alert("passaInVerificaDaSelezione");

        that.passaInVerificaDaSelezione(value);
      }
    },
    passaInVerificaDaSelezione(value) {
      var that = this;

      that.azzera_Rif_PlatesThickness();

      that.designPressureValue_postSele = value.idDesignPressureValue;

      that.platesMaterialValue_postSele = value.idPlatesMaterialValue;
      that.platesThicknessValue_postSele = value.idPlatesThickness;
      that.gasketsMaterialValue_postSele = value.idGasketsMaterialValue;

      that.framesMaterialValue_postSele = value.idFramesMaterialValue;
      that.sizeGeometryValue_postSele = value.idSizeGeometry;
      that.typeGeometryValue_postSele = value.idTypeGeometry;

      that.$store.commit("bDisableNextDaSpalla", false);
      this.lockAllvalue = true;
    },

    bDisableNextDaSpalla() {
      if (!this.lockAll) {
        this.$store.commit("bDisableNextDaSpalla", true);
      }
    },

    mostraCodice() {
      var that = this;
      if (that.TipoCNN_ByCODE_isActive == false) {
        that.TipoCNN_ByCODE_showModal = true;
      } else {
        that.TipoCNN_ByCODE_showModal = false;

        // Reset
        that.TipoCNN_ByCODE_isActive = false;
        that.TipoCNN_ByCODE_Text = "...";
        that.settaValoreDiretto("shoulder.tipoCNN_ByCODE", "");
      }
    },
    elaboraCodice() {
      var that = this;
      if (that.TipoCNN_ByCODE_isActive == false) {
        if (this.CodeToSet != "") {
          geometryPHEServiceCipriani
            .scambiatoreDaCodice(this.CodeToSet, this.typeOfPheValue)
            .then(function(data) {
              if (data == null)
                Notification.warning({
                  message: that.uniTranslation("PHE10216")
                });
              else {
                that.impostaDatiModelloCambiaModalita(data);
                that.TipoCNN_ByCODE_isActive = true;
                that.TipoCNN_ByCODE_Text = "X";
              }

              that.CodeToSet = "";
            });
        }
      }
    },
    impostaDatiModelloCambiaModalita(val) {
      this.azzera_Rif_PlatesThickness();

      this.impostaDatiModello(val);

      // ************************
      // Questi tre valori non vanno modificati
      // ************************
      //this.settaValoreDiretto("shoulder.idCalculationModeValue", val.idCalculationModeValue);
      //this.settaValoreDiretto("shoulder.idProductLineValue", val.idProductLineValue);
      //this.settaValoreDiretto("shoulder.idDesignStandardValue", val.idDesignStandardValue);
      // ************************

      //this.settaValoreDiretto("shoulder.idTypeOfPheValue", val.idTypeOfPheValue);
      //this.settaValoreDiretto("shoulder.idDesignPressureValue", val.idDesignPressureValue);
      //this.settaValoreDiretto("shoulder.idPlatesMaterialValue", val.idPlatesMaterialValue);
      //this.settaValoreDiretto("shoulder.idGasketsMaterialValue", val.idGasketsMaterialValue);
      //this.settaValoreDiretto("shoulder.idFramesMaterialValue", val.idFramesMaterialValue);

      //this.settaValoreDiretto("shoulder.idPlatesThickness", val.idPlatesThickness);
      //this.settaValoreDiretto("shoulder.idSizeGeometry", val.idSizeGeometry);
      //this.settaValoreDiretto("shoulder.idTypeGeometry", val.idTypeGeometry);

      //this.$store.dispatch("refreshSettaScambiatoreDadCodice");

      //alert("1");
      var typeOfPheValue = val.idTypeOfPheValue;
      var designPressureValue = val.idDesignPressureValue;
      var platesMaterialValue = val.idPlatesMaterialValue;
      var gasketsMaterialValue = val.idGasketsMaterialValue;
      var framesMaterialValue = val.idFramesMaterialValue;
      var platesThicknessValue = val.idPlatesThickness;
      var sizeGeometryValue = val.idSizeGeometry;
      var typeGeometryValue = val.idTypeGeometry;

      //alert("2");
      if (typeOfPheValue && typeOfPheValue >= 0) {
        this.typeOfPheValue_postSele = typeOfPheValue;
      }
      if (designPressureValue && designPressureValue >= 0) {
        this.designPressureValue_postSele = designPressureValue;
      }
      if (platesMaterialValue && platesMaterialValue >= 0) {
        this.platesMaterialValue_postSele = platesMaterialValue;
      }
      if (gasketsMaterialValue && gasketsMaterialValue >= 0) {
        this.gasketsMaterialValue_postSele = gasketsMaterialValue;
      }
      if (framesMaterialValue && framesMaterialValue >= 0) {
        this.framesMaterialValue_postSele = framesMaterialValue;
      }
      if (platesThicknessValue && platesThicknessValue >= 0) {
        this.platesThicknessValue_postSele = platesThicknessValue;
      }
      if (sizeGeometryValue && sizeGeometryValue >= 0) {
        this.sizeGeometryValue_postSele = sizeGeometryValue;
      }
      if (typeGeometryValue && typeGeometryValue >= 0) {
        this.typeGeometryValue_postSele = typeGeometryValue;
      }

      //alert("3");
      if (this.typeOfPheValue != this.typeOfPheValue_postSele) {
        this.typeOfPheValue = this.typeOfPheValue_postSele;
      }
      if (this.designPressureValue != this.designPressureValue_postSele) {
        this.designPressureValue = this.designPressureValue_postSele;
      }
      if (this.platesMaterialValue != this.platesMaterialValue_postSele) {
        this.platesMaterialValue = this.platesMaterialValue_postSele;
      }
      if (this.gasketsMaterialValue != this.gasketsMaterialValue_postSele) {
        this.gasketsMaterialValue = this.gasketsMaterialValue_postSele;
      }
      if (this.framesMaterialValue != this.framesMaterialValue_postSele) {
        this.framesMaterialValue = this.framesMaterialValue_postSele;
      }
      if (this.platesThicknessValue != this.platesThicknessValue_postSele) {
        this.platesThicknessValue = this.platesThicknessValue_postSele;
      }
      if (this.sizeGeometryValue != this.sizeGeometryValue_postSele) {
        this.sizeGeometryValue = this.sizeGeometryValue_postSele;
      }
      if (this.typeGeometryValue != this.typeGeometryValue_postSele) {
        this.typeGeometryValue = this.typeGeometryValue_postSele;
      }
      //alert("4");
      this.settaValoreDiretto("shoulder.tipoCNN_ByCODE", val.tipoCNN_ByCODE);
    },
    impostaDatiModello(val) {
      this.settaValoreParent("bottom.numberOfPlates", val.numeroDiPiastre, true, true, true);
      this.settaValoreParent(
        "bottom.numberOfCircuitsPrimarySide",
        val.numberOfCircuitsPrimario,
        true,
        true,
        true
      );
      this.settaValoreParent(
        "bottom.numberOfCircuitsSecondarySide",
        val.numberOfCircuitsSecondario,
        true,
        true,
        true
      );

      this.settaValoreDiretto(
        "bottom.highPerformancePlatePercentageValue",
        val.percentualeAltaResa
      );
      this.settaValoreDiretto("ciprianI_PERCENTUALE_Selezionata", val.percentualeExtraPiastre);

      this.$store.dispatch("refreshAll");
    }
  }
};
</script>

<style lang="scss">
.card .card-header {
  background-color: transparent;
  padding: 0px;
}

label {
  margin-bottom: 0px;
}

div {
  hr {
    margin-bottom: 10px;
    margin-top: 10px;
    border: solid;
    border-width: 1px;
    width: 90%;
    height: 0px;
    /* Set the hr color */
    color: #333; /* old IE */
    background-color: #333; /* Modern Browsers */
  }
}

.pheShoulderLabel {
  //margin-top: 5px;
  //padding-left: 5px;
  margin-bottom: 0rem !important;
}
.pheShoulderSelect {
  width: 100%;
  margin-bottom: 4px;
  //margin-top: 5px;
  //padding: 0 5px;
  .el-input {
    .el-input__inner {
      height: 30px !important;
    }
  }
}
</style>
